// extracted by mini-css-extract-plugin
export var container = "index-module--container--3t9nn";
export var loadinganimation = "index-module--loadinganimation--M9WjB";
export var small = "index-module--small--2bhP3";
export var medium = "index-module--medium--Azfsm";
export var large = "index-module--large--1pUNi";
export var white = "index-module--white--2AOdy";